export default __webpack_public_path__ + "static/social-mapa_en-1e3490a2277091ccadcc0f6de827a6bc.png";